export class RemittanceSummary {
  constructor(
    public DepositAmount: number = 0.00,
    public RemittanceRecordCount: number = 0,
    public RemittanceTotal: number = 0.00,
    public Variance: number = 0.00,
    public UnvalidatedPostedClaims: number = 0,
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/remittance-summary.model.ts